'use client';

import { CenteredContent } from '@/components/CenteredContent';
import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import {
  ButtonGroup,
  GlobalStyles,
  Link,
  Text,
} from '@/lib/mx-asurion-ui-react';
import Image from 'next/image';
import ErrorImage from 'public/images/500.png';
import styled from 'styled-components';

const ImageWrapper = styled.div`
  & > img {
    width: 665px;
    height: auto;
    max-width: 90vw;
  }
`;

const InnerWrapper = styled.div`
  & > * {
    text-align: center;
    margin-bottom: 1.5rem;
  }
`;

export default function GlobalError() {
  return (
    <>
      <Header />
      <CenteredContent headerHeight={70} footerHeight={210}>
        <GlobalStyles />
        <InnerWrapper>
          <Text as="h1" size={7} weight="feather">
            Something&rsquo;s not right
          </Text>
          <Text as="p">
            That&rsquo;s entirely our fault.
            <br />
            Please try again in a few minutes.
          </Text>
          <ButtonGroup alignment="center">
            <Link
              href="https://www.asurion.com"
              variant="button"
              rel="noopener noreferrer"
            >
              Take me to Asurion.com
            </Link>
          </ButtonGroup>
          <ImageWrapper>
            <Image src={ErrorImage} alt="" />
          </ImageWrapper>
        </InnerWrapper>
      </CenteredContent>
      <Footer linkData={[]} />
    </>
  );
}
